<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-6">
        <a @click="openPage('/allForm')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
      </div>
    </div>
    <div class="box">
      <div class="p-20">
        <div class="row mt-10">
          <div class="col-sm-6">
            <b-row>
              <b-col sm="3">
                <label>Type</label>
              </b-col>
              <b-col sm="9">
                <b-form-select @change="changeFormType" name="formType" v-model="formType" :options="options" class="mb-3" />
              </b-col>
            </b-row>
          </div>
          <div class="col-sm-6">
            <b-row>
              <b-col sm="3">
                <label>Branch</label>
              </b-col>
              <b-col sm="9">
                <b-form-select name="branch" v-model="addData.branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                  <div v-if="branch_validate">
                    <span class="error">The Branch field is required.</span>
                  </div>
              </b-col>
            </b-row>
          </div>
        </div>
        <template v-if="formType === 'lostAndFound'">
          <form @submit.prevent="validateLostAndFound('lostAndFound')" data-vv-scope="lostAndFound">
            <div class="row justify-content-center mt-30">
              <div class="col-sm-6">
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Item Name</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom" name="item_name" v-validate="'required'" v-model="addData.what_item" type="text"></b-form-input>
                    <span class="error">{{ errors.first('lostAndFound.item_name') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Detail</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom" name="detail" v-validate="'required'" v-model="addData.detail_reason" type="text"></b-form-input>
                    <span class="error">{{ errors.first('lostAndFound.detail') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Employee ID</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-select @change="getCSData" class="border-bottom" name="customer_service_id" v-validate="'required'" v-model="addData.customer_service_id">
                      <option :value="null">Please select</option>
                      <option v-for="item in dataCS" :key="item.id" :value="item.id">
                        <template v-if="item.branch">{{item.branch.codename}}</template><template v-else>XX</template>-{{item.id}}
                      </option>
                    </b-form-select>
                    <span class="error">{{ errors.first('lostAndFound.customer_service_id') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Customer Service Name</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom bg-transparent" disabled v-model="CSName" type="text"></b-form-input>
                  </b-col>
                </b-row>
              </div>
              <div class="col-sm-6">
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Founder Name</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom" name="founder_name" v-validate="'required'" v-model="addData.which_found_name" type="text"></b-form-input>
                    <span class="error">{{ errors.first('lostAndFound.founder_name') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Area/Location</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input class="border-bottom" name="location" v-validate="'required'" v-model="addData.which_area" type="text"></b-form-input>
                    <span class="error">{{ errors.first('lostAndFound.location') }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Time Found</label>
                  </b-col>
                  <b-col sm="9">
                    <flat-pickr :config="configTimeDate" v-model="addData.time_found" name="time_found" class="w-100 border-bottom"></flat-pickr>
                    <span class="error">{{ errors.first('lostAndFound.time_found') }}</span>
                  </b-col>
                </b-row>
              </div>
            </div>
            <div class="text-right">
              <button type="submit" class="btn-primary">Submit</button>
            </div>
          </form>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'

export default {
  name: 'addbranch',
  data: function () {
    return {
      errorMoney: 'The amount field is required!',
      dataMember: [],
      dataBranch: [],
      dataCS: [],
      config: {
        altInput: true,
        altFormat: 'F j, Y',
        dateFormat: 'Y-m-d'
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      money2: {
        decimal: ',',
        thousands: '.',
        prefix: 'IDR ',
        suffix: '',
        precision: 0,
        masked: false
      },
      formType: 'lostAndFound',
      itemsPaymentCard: [],
      itemsPaymentType: [],
      detailMember: {},
      detailCS: {},
      CSName: '',
      modalShow: false,
      linkPrivyId: 'https://sandbox.privy.id/user',
      config2: {
        enableTime: true,
        noCalendar: true,
        defaultDate: "00:00",
        static: true,
        time_24hr: true
      },
      config: {
        enableTime: true,
        noCalendar: true,
        defaultDate: "00:00",
        time_24hr: true
      },
      configTimeDate: {
        enableTime: true,
        noCalendar: false,
        // defaultDate: "00:00",
        altInput: true,
        altFormat: "j F Y, H:i",
        time_24hr: true
      },
      branch_validate: false,
      addData: {
        branch_id: null,
        customer_service_id: null,
        detail_reason: '',
        which_found_name: '',
        which_area: '',
        time_found: '',
        what_item: '',
        who_return_item_name: '',
        return_item_time: '',
        customer_service_serve_id: ''
      },
      options: [
        { value: null, text: 'Please select' },
        { value: 'freeze', text: 'Freeze' },
        { value: 'cancel', text: 'Cancel' },
        { value: 'outstanding', text: 'Outstanding' },
        { value: 'wristband', text: 'Wristband' },
        { value: 'lostAndFound', text: 'Lost & Found' },
        { value: 'dailyVisit', text: 'Daily Visit' },
        { value: 'grabAndGo', text: 'Grab & Go' },
        { value: 'grabAndGoGopay', text: 'Grab & Go Gopay' },
        { value: 'extendPt', text: 'Extend PT' },
        { value: 'corporateOutstanding', text: 'Corporate Invoice Outstanding' },
        { value: 'merchandise', text: 'Merchandise' },
        { value: 'starterPack', text: 'Starter Pack' }
      ]
    }
  },
  methods: {
    changeFormType (event) {
      if (event === 'freeze') {
        this.$router.push('/allForm/addFreeze')
      } else if (event === 'cancel') {
        this.$router.push('/allForm/addCancel')
      } else if (event === 'outstanding') {
        this.$router.push('/allForm/addOutstanding')
      } else if (event === 'wristband') {
        this.$router.push('/allForm/addWristband')
      } else if (event === 'lostAndFound') {
        this.$router.push('/allForm/addLostAndFound')
      } else if (event === 'dailyVisit') {
        this.$router.push('/allForm/addDailyVisit')
      } else if (event === 'grabAndGo') {
        this.$router.push('/allForm/addGrabAndGo')
      } else if (event === 'grabAndGoGopay') {
        this.$router.push('/allForm/addgrabAndGoGopay')
      } else if (event === 'corporateOutstanding') {
        this.$router.push('/allForm/addCorporateOutstanding')
      } else if (event === 'extendPt') {
        this.$router.push('/allForm/addExtendPt')
      } else if (event === 'merchandise') {
        this.$router.push('/allForm/addMerchandise')
      } else if (event === 'starterPack') {
        this.$router.push('/allForm/addStarterPack')
      } else {
        this.$router.push('/allForm/add')
      }
    },
    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    changePaymentType1 (event) {
      if (event === 1 || event === 6) {
        this.addData.payment_card_id_1 = null
      }
    },
    changePaymentType2 (event) {
      if (event === 1 || event === 6) {
        this.addData.payment_card_id_2 = null
      }
    },
    getMemberData (event) {
      axios.get('fitness/v1/member/' + event).then(response => {
        this.detailMember = response.data.data
        this.addDataPrivy.branch_id = response.data.data.branch_id
        this.addDataPrivy.member_id = response.data.data.id
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
    },
    getCSData (event) {
      axios.get('crm/v1/customer_service/' + event).then(response => {
        this.detailCS = response.data.data
        this.CSName = response.data.data.name
        this.addDataPrivy.customer_id = response.data.data.id
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
    },
    formSelect (event) {
      return event
    },
    changeValueMoney (event) {
      if (!(event.key === '')) {
        this.$refs['error-print'].classList.add('hidden')
      } else {
        this.$refs['error-print'].classList.remove('hidden')
      }
    },
    validateLostAndFound (data5) {
      this.$validator.validateAll(data5).then((result) => {
        if (this.addData.branch_id == null) {
          this.branch_validate = true
          this.$toast.success('The Branch field is required!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
          return
        }
        if(result) {
          axios.post('crm/v1/form_lost_found/', this.addData).then(response => {
            // console.log('test', response)
            this.$router.push('/allForm')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error log', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    changeBranch(event) {
      this.branch_validate = false
      axios.get('crm/v1/customer_service?branch_id=' + event).then(response => {
        this.dataCS = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    fetchData() {
      // this.addData.customer_service_id = Auth.Session.get().paradigm_id
      // axios.get('fitness/v1/member/').then(response => {
      //   this.dataMember = response.data.data.rows
      //   // console.log('test', response)
      // }).catch(error => {
      //   console.log('error', error)
      // })
      axios.get('transaction/v1/payment_card').then(response => {
        this.itemsPaymentCard = response.data.data.rows
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('transaction/v1/payment_type').then(response => {
        this.itemsPaymentType = response.data.data.rows
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/customer_service/').then(response => {
        this.dataCS = response.data.data.rows

        if (Auth.Session.get().paradigm_role == 6 || Auth.Session.get().paradigm_role == '6') {
          // filter cs member
          this.dataCS = this.dataCS.filter(cs => cs.id == Auth.Session.get().paradigm_id)
        }
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows

        if (Auth.Session.get().paradigm_role == 6 || Auth.Session.get().paradigm_role == '6') {
          // filter branch member
          this.dataBranch = this.dataBranch.filter(branch => branch.id == Auth.Session.get().paradigm_branch_id)
        }
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()

    const roleId = Auth.Session.get().paradigm_role
    if (roleId == 6 || roleId == '6') {
      this.addData.branch_id = Auth.Session.get().paradigm_branch_id
      this.addData.customer_service_id = Auth.Session.get().paradigm_id

      this.getCSData(this.addData.customer_service_id)
    }
  }
}
</script>

<style>
</style>
